import { AppAreaConfig } from '@/funnels/@types'
import maleActivityMilitaryCalisthenicsPr from './activity-male-military-calisthenics-pr'
import femaleActivityMilitaryCalisthenicsPr from './activity-female-military-calisthenics-pr'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main-military-calisthenics-pr',
	options: {
		userTags: ['calisthenics'],
	},
	landing: {
		ids: ['loader-military-calisthenics', 'age-military-calisthenics-pr'],
		route: {
			path: '/military-calisthenics-pr',
			name: 'main-military-calisthenics-pr-funnel',
		},
	},
	funnel: {
		// Reuse the base gender-selection OB; the printable redirect target is driven by
		// redirectTo.sex below (perf-web), not the OB. Mirrors how male/female -pr reuse their base OBs.
		id: 'ob-military-calisthenics-gender-selection',
		route: {
			path: '/military-calisthenics-pr/ob/:page(.*)?',
			name: 'main-military-calisthenics-pr',
		},
		slug: 'main-military-calisthenics-pr',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
		redirectTo: {
			sex: {
				male: { appArea: maleActivityMilitaryCalisthenicsPr },
				female: { appArea: femaleActivityMilitaryCalisthenicsPr },
			},
		},
	},
}

export default appAreaConfig
